import { IconProps } from '../../Interfaces/Props'

const IconClose2 = (props: IconProps) => {
    if (!!props.fill) {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" className={props.className} width={props.size ?? 24} height={props.size ?? 24} viewBox="0 0 24 24"><path fill="currentColor" d="M15.1 3.1L12.9.9L8 5.9L3.1.9L.9 3.1l5 4.9l-5 4.9l2.2 2.2l4.9-5l4.9 5l2.2-2.2l-5-4.9z" /></svg>
        )
    } else {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" className={props.className} width={props.size ?? 24} height={props.size ?? 24} viewBox="0 0 24 24"><path fill="currentColor" d="M3 16.74L7.76 12L3 7.26L7.26 3L12 7.76L16.74 3L21 7.26L16.24 12L21 16.74L16.74 21L12 16.24L7.26 21zm9-3.33l4.74 4.75l1.42-1.42L13.41 12l4.75-4.74l-1.42-1.42L12 10.59L7.26 5.84L5.84 7.26L10.59 12l-4.75 4.74l1.42 1.42z" /></svg>
        )
    }
}

export default IconClose2